import { AppApiGateway } from '@repo/api/web/AppApiGateway'
import type { UpdateCart } from '@repo/api/web/models'
import { inject, injectable } from 'inversify'

@injectable()
export class CartService {
  protected appConfig: ReturnType<typeof useAppConfig>

  constructor(
    @inject(AppApiGateway)
    readonly api: AppApiGateway,
  ) {
    this.appConfig = useAppConfig()
  }

  getCart() {
    return this.api.cartsList(this.appConfig.host)
  }

  updateCart(model: UpdateCart) {
    return this.api.cartsUpdate(this.appConfig.host, model)
  }

  clearCart() {
    return this.api.cartsClear(this.appConfig.host)
  }

  removeProduct(productId: number) {
    return this.api.cartsRemoveProduct(productId, this.appConfig.host)
  }

  notifyProduct(productId: number) {
    return this.api.cartsNotify(productId, this.appConfig.host)
  }

  unnotifyProduct(productId: number) {
    return this.api.cartsNotNotify(productId, this.appConfig.host)
  }
}
